export const COLUNAS_DEFAULT_MODULE_PEDIDO = [
  {
    module: 'PEDIDOS',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'data',
        active: true,
        removable: true
      },
      { field: 'status', active: true, removable: true }
    ]
  }
];
